import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import { makeStyles } from 'src/makeStyles';
import { connect, useDispatch } from 'react-redux';
import { compose } from 'redux';
import debounce from 'lodash/debounce';
import { createStructuredSelector } from 'reselect';
import { withTranslation, Router } from '../../src/i18n';
import { PROFILES_ENDPOINT } from '../../constants/endpointConstants';
import Button from '../Button';
import { selectComposersSearchList, selectComposersSearchListLoading } from '../../containers/Composers/selectors';
import route from '../../constants/routes';
import { getList } from '../../containers/App/actions';
import { TP, PROFESSION_IDS } from '../../constants/consts';
import { getComposerSearchListAction, clearComposersSearchAction } from '../../containers/Composers/actions';
import { getRouteWithSlug } from '../../utils/common';
import FormikSearchField from '../Fields/SearchField/FormikSearchField';

const useStyles = makeStyles()(theme => ({
  form: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  searchForm: {
    justifyContent: 'space-between',
  },
  submitButton: {
    fontSize: '0.9rem',
    padding: '12px',
    fontWeight: 'bold',
    minWidth: '68px',
    lineHeight: 1,
    marginTop: 16,
    '& span': {
      lineHeight: 1,
    },
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
    },
    marginBottom: '3px',
  },
  filtersSearchItem: {
    width: '100%',
    maxWidth: '360px',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
    '& input': {
      fontSize: '18px',
      height: '27px',
    },
  },
  filtersCountryItem: {
    width: '100%',
    maxWidth: '200px',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      marginBottom: 15,
    },
    '& input': {
      fontSize: '18px',
    },
  },
}));

export const composerFormFields = {
  composerName: 'query',
};

const ComposerSearchFilter = ({ t, submitFunc, composerLoading, composerList }) => {
  const { classes, cx } = useStyles();
  const dispatch = useDispatch();
  const composersInitialValues = {
    [composerFormFields.composerName]: '',
  };

  const searchComposersByName = debounce(values => {
    dispatch(
      getList({
        endpoint: PROFILES_ENDPOINT,
        sagaRoutine: getComposerSearchListAction,
        params: { query: values, filter: { profession_id: PROFESSION_IDS.COMPOSER } },
      }),
    );
  }, 500);

  return (
    <Formik initialValues={composersInitialValues} enableReinitialize onSubmit={values => submitFunc(values)}>
      {({ values }) => (
        <Form className={cx(classes.form, { [classes.searchForm]: false })} autoComplete="off">
          <div className={classes.filtersSearchItem}>
            <Field
              name={composerFormFields.composerName}
              id={composerFormFields.composerName}
              placeholder={`${t(`${TP}.m_ENTERNAME`)}`}
              label={t(`${TP}.FN_SEARCH_COMPOSERS`)}
              onEnter={() => submitFunc(values)}
              options={composerList}
              onInputTextChange={v => {
                if (v) {
                  return searchComposersByName(v);
                }
                dispatch(clearComposersSearchAction());
              }}
              onChange={v => {
                Router.push(`${route.ARTISTS}/[id]/[[...action]]`, getRouteWithSlug(route.ARTISTS, v));
              }}
              onFocus={v => {
                if (v && v.length >= 1) {
                  return searchComposersByName(v);
                }
              }}
              isLoading={composerLoading}
              component={FormikSearchField}
            />
            <Button className={classes.submitButton} type="submit">
              {t(`${TP}.m_GOBUTTON`)}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

ComposerSearchFilter.propTypes = {
  t: PropTypes.func.isRequired,
  submitFunc: PropTypes.func,
  composerList: PropTypes.array,
  composerLoading: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  composerLoading: selectComposersSearchListLoading(),
  composerList: selectComposersSearchList(true),
});

const withConnect = connect(mapStateToProps, null);

export default compose(withTranslation(), withConnect)(ComposerSearchFilter);
